import {MoveRatingCategories} from "../utils/gameEnums";

const CATEGORIES = [
    MoveRatingCategories.BEST_MOVE,
    MoveRatingCategories.GOOD_MOVE,
    MoveRatingCategories.ALRIGHT_MOVE,
    MoveRatingCategories.INACCURACY,
    MoveRatingCategories.MISTAKE,
    MoveRatingCategories.BLUNDER
];

const count = (ratings, category) => ratings.filter((rating) => rating.category === category).length;

// Counts best moves, mistakes, blunders... for both players
const AnalysisOverview = ({whiteMoveRatings, blackMoveRatings, whiteName = "White", blackName = "Black"}) => {
    return (
        <table className="overview-table">
            <thead>
            <tr>
                <th style={{textAlign: "center"}} title={whiteName}>White</th>
                <th/>
                <th style={{textAlign: "center"}} title={blackName}>Black</th>
            </tr>
            </thead>
            <tbody>
            {CATEGORIES.map((category) => (
                <tr key={category.title}>
                    <td className="count">{count(whiteMoveRatings, category)}</td>
                    <td>
                        <div className="label-cell" style={{justifyContent: "center"}}>
                            <span className="badge">{category.symbol(18)}</span>
                            {category.title}
                        </div>
                    </td>
                    <td className="count">{count(blackMoveRatings, category)}</td>
                </tr>
            ))}
            </tbody>
        </table>
    )
}

export default AnalysisOverview;
